import * as _hm from './_hm';
import * as _ht from './_ht';
import * as _gv from './_gv';

import * as icv from './icv';

import * as gs from './_gv'; // server 適用外

export const vdd = (bVsn?: _ht.b, bDmn?: _ht.b, bDlt?: _ht.b) => { // version, domain, delete : common condition
  const _gUserz = gs.useUserz();
  let _cdn = '';
  if (bVsn ?? true) _cdn += (_cdn == '' ? ' ' : ' AND ') + `_vsn = _ltt`;
  if (bDmn ?? true) _cdn += (_cdn == '' ? ' ' : ' AND ') + `_dmn = ${_gUserz.crt._20rz?._key}`
  if (bDlt ?? true) _cdn += (_cdn == '' ? ' ' : ' AND ') + `COALESCE(_dlt,-1) <> 1`
  return _cdn;
};

const ufmDatz = (pz: _ht.dz, dmn?: _ht.n) => { // server 適用外
  const _gUserz = gs.useUserz();
  return {
    ... pz,
    _dmn: dmn ?? _gUserz.crt._20rz?._key,
    _who: _gUserz.crt._10rz?._key,
  }
};

export const ectAsync = async (pz: { // execute
  tgt: _ht.s,
  dz: _ht.dz,
}) => {
  const _url = icv.appz?.urlb + '/ect';
  const _dz = pz;
  const _dz2 = await sendAsync({
    url: _url,
    mtd: 'POST',
    dz: _dz,
  })
  if (!_dz2.err) {
    return _dz2.data;
  }
  else {
    return null;
  }
};

export const sendAsync = (pz: {
  url: _ht.s,
  mtd?: 'POST' | 'GET',
  dz?: _ht.dz,
  hdrz?: _ht.dz,
}):Promise<{ err?: _ht.s|null, data?: _ht.a| null }> => new Promise( _exit1 => {
  const _dz = {
    mode: 'cors',
    method: pz.mtd ?? 'POST',
    body: pz.dz ? _hm.s(pz.dz) : null,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      ... pz.hdrz,
    },
  };
//_hm.l(`cmFTH 60:` + _hm.s(_dz));
  fetch(pz.url, _dz as _ht.a)
  .then( (_rst: _ht.a) => _rst.json())
  .then( (_rst: _ht.a) => {
    _exit1({ err: null, data: ((_rst) ? _rst : null) });
  })
  .catch( _err => {
    _exit1({ err: _err, data: null });
  });
});

export const loadAllAsync = async (pz: { // server 適用外
  frcUdt?: () => void,
  ldrz?: _ht.dz,
  phs?: _ht.s,
  bfrAsync?: () => _ht.ls,
  crtAsync?: () => _ht.ls,
  udtAsync?: () => _ht.ls,
  atrAsync?: () => _ht.ls,
}) => {
  if (pz.ldrz) pz.ldrz.show();
  //hf.l(`cmFTH 73: here`);
  if (pz.bfrAsync) await Promise.all(pz.bfrAsync());
  //hf.l(`cmFTH 75: here`);
  if ( pz.phs == 'crt' ) { // new
    if (pz.crtAsync) await Promise.all(pz.crtAsync());
  }
  else { // edit
    if (pz.udtAsync) await Promise.all(pz.udtAsync());
  }
  if (pz.atrAsync) await Promise.all(pz.atrAsync());
  if (pz.ldrz) pz.ldrz.hide();
  //hf.l(`cmFTH 84: here`);
  if (pz.frcUdt) pz.frcUdt();
  //hf.l(`cmFTH 86: here`);
};

export const loadLsAsync = async (pz: {
  tgt: _ht.s, 
  cdn?: _ht.s,
  fld?: _ht.s,
  tailz?: {
    odr?: _ht.s,
    ost?: _ht.n,
    lmt?: _ht.n,
  },
  lwrz?: _ht.dz,
}) => {
  const _url = icv.appz?.urlb + '/findAll';
  const _dz = {
    ... pz,
    fld: pz.fld ?? '_fst as key, _pfx as pfx, *',
  };
  const _dz2 = await sendAsync({
    url: _url,
    mtd: 'POST',
    dz: _dz,
  });
  if (!_dz2.err) {
    return _dz2.data;
  }
  else {
    return null;
  }
};

export const loadLsAsync2 = async (pz: _ht.dz) => {
  const _url = icv.appz?.urlb + '/findAll2';
  const _gUserz = _gv.useUserz();
  const _dz = {
    _dmn: _gUserz.crt._20rz._key ?? -1,
    fld: pz.fld ?? '_fst as key, _pfx as text, *',
    ... pz,
  };
  //_hm.l(`cmFTH 134: ${_url}`);
  const _dz2 = await sendAsync({
    url: _url,
    mtd: 'POST',
    dz: _dz,
  });
  if (!_dz2.err) {
    return _dz2.data;
  }
  else {
    return null;
  }
};

export const loadDzAsync = async (pz: {
  tgt: _ht.s, 
  cdn: _ht.s,
  fld?: _ht.s,
  lwrz?: _ht.dz,
}) => {
  const _url = icv.appz?.urlb + '/findOne';
  const _dz = {
    ... pz,
    fld: pz?.fld ?? '*',
  };
  const _dz2 = await sendAsync({
    url: _url,
    mtd: 'POST',
    dz: _dz,
  });

  if (!_dz2.err) {
    return _dz2.data;
  }
  else {
    return null;
  }
};

export const loadDzAsync2 = async (pz: _ht.dz) => {
  const _url = icv.appz?.urlb + '/findOne2';
  const _gUserz = _gv.useUserz();
  const _dz = {
    _dmn: _gUserz.crt._20rz._key ?? -1,
    fld: pz?.fld ?? '*',
    ... pz,
  };
  const _dz2 = await sendAsync({
    url: _url,
    mtd: 'POST',
    dz: _dz,
  });

  if (!_dz2.err) {
    return _dz2.data;
  }
  else {
    return null;
  }
};

export const ugdDzAsync = async (pz: { // upgrade
  tgt: _ht.s, 
  dmn?: _ht.n,
  dz: _ht.dz,
  lwrz?: _ht.dz,
  atrs?: _ht.ls, // 後処理
}) => {
  const _url = icv.appz?.urlb + '/ugdOne';
  const _dz = {
    ... pz,
    dz: ufmDatz(pz.dz, pz.dmn), // server は ufmDatz 適用外
  };
  const _dz2 = await sendAsync({
    url: _url,
    mtd: 'POST',
    dz: _dz,
  })
  if (!_dz2.err) {
    return _dz2.data;
  }
  else {
    return null;
  }
};

export const ugdDzAsync2 = async (pz: _ht.dz) => {
  const _url = icv.appz?.urlb + '/ugdOne2';
  const _gUserz = _gv.useUserz();
  const _dz = {
    _dmn: _gUserz.crt._20rz._key ?? -1,
    _who: _gUserz.crt._10rz._key ?? -1,
    ... pz,
  };
  const _dz2 = await sendAsync({
    url: _url,
    mtd: 'POST',
    dz: _dz,
  })
  if (!_dz2.err) {
    return _dz2.data;
  }
  else {
    return null;
  }
};

export const upsDzAsync = async (pz: { // upsert
  tgt: _ht.s, 
  dmn?: _ht.n,
  cdn?: _ht.s,
  dz: _ht.dz,
  atrs?: _ht.ls, // 後処理
  lwrz?: _ht.dz,
}) => {
  const _url = icv.appz?.urlb + '/upsAll';
  const _dz = {
    ... pz,
    dz: ufmDatz(pz.dz, pz.dmn), // server は ufmDatz 適用外
  };
  const _dz2 = await sendAsync({
    url: _url,
    mtd: 'POST',
    dz: _dz,
  })
  if (!_dz2.err) {
    return _dz2.data;
  }
  else {
    return null;
  }
};

export const upsDzAsync2 = async (pz: _ht.dz) => {
  const _url = icv.appz?.urlb + '/upsAll2';
  const _gUserz = _gv.useUserz();
  const _dz = {
    _dmn: _gUserz.crt._20rz._key ?? -1,
    _who: _gUserz.crt._10rz._key ?? -1,
    ... pz,
  };
  const _dz2 = await sendAsync({
    url: _url,
    mtd: 'POST',
    dz: _dz,
  })
  if (!_dz2.err) {
    return _dz2.data;
  }
  else {
    return null;
  }
};

export const sendCodeAsync = async (pz: { // 廃止予定
  dmn: _ht.n,
  eml: _ht.s, 
  _10rt1100i: _ht.n,
}) => {
  const _url = icv.appz?.urlb + '/sendCode';
  const _dz = {
    ... pz,
  };
  const _dz2 = await sendAsync({
    url: _url,
    mtd: 'POST',
    dz: _dz,
  });
  if (!_dz2.err) {
    return _dz2.data;
  }
  else {
    return null;
  }
};

export const sendCodeAsync2 = async (pz: {
  _dmn: _ht.n,
  _10ra1100s: _ht.s, 
  _10rt1100i?: _ht.n,
}) => {
  const _url = icv.appz?.urlb + '/sendCode2';
  const _dz = {
    ... pz,
  };
  const _dz2 = await sendAsync({
    url: _url,
    mtd: 'POST',
    dz: _dz,
  });
  if (!_dz2.err) {
    return _dz2.data;
  }
  else {
    return null;
  }
};

export const cfmCodeAsync = async (pz: { // confirm
  dmn: _ht.n,
  eml: _ht.s, 
  code: _ht.s,
  _10rt1100i: _ht.n,
}) => {
  const _url = icv.appz?.urlb + '/cfmCode';
  const _dz = {
    ... pz,
  };
  const _dz2 = await sendAsync({
    url: _url,
    mtd: 'POST',
    dz: _dz,
  });
  if (!_dz2.err) {
    return _dz2.data as _ht.dz;
  }
  else {
    return null;
  }
};

export const cfmCodeAsync2 = async (pz: { // confirm
  _dmn: _ht.n,
  _10ra1100s: _ht.s, 
  _00ra1100s: _ht.s,
  _10rt1100i?: _ht.n,
}) => {
  const _url = icv.appz?.urlb + '/cfmCode2';
  const _dz = {
    ... pz,
  };
  const _dz2 = await sendAsync({
    url: _url,
    mtd: 'POST',
    dz: _dz,
  });
  if (!_dz2.err) {
    return _dz2.data as _ht.dz;
  }
  else {
    return null;
  }
};

export const cfmIdAsync = async (pz: { // confirm
  dmn: _ht.n,
  id: _ht.s, 
  cdn?: _ht.s,
  pwd: _ht.s,
}) => {
  const _url = icv.appz?.urlb + '/cfmId';
  const _dz = {
    ... pz,
  };
  const _dz2 = await sendAsync({
    url: _url,
    mtd: 'POST',
    dz: _dz,
  });
  if (!_dz2.err) {
    return _dz2.data;
  }
  else {
    return null;
  }
};

export const cfmNbrAsync = async (pz: { // confirm
  id: _ht.s, 
  code: _ht.s,
}) => {
  const _url = icv.appz?.urlb + '/cfmNbr';
  const _dz = {
    ... pz,
  };
  const _dz2 = await sendAsync({
    url: _url,
    mtd: 'POST',
    dz: _dz,
  });
  if (!_dz2.err) {
    return _dz2.data;
  }
  else {
    return null;
  }
};

export const sendMailAsync = async (pz: { // sendmail
  tos?: _ht.s[] | _ht.s,
  bccs?: _ht.s[] | _ht.s,
  sjt?: _ht.s,
  msg?: _ht.s,
}) => {
  const _url = icv.appz?.urlb + '/mail';
  const _dz = {
    ... pz,
  };
  const _dz2 = await sendAsync({
    url: _url,
    mtd: 'POST',
    dz: _dz,
  });
  await _hm.waitAsync(1000); // 連続送信を抑制
  return _dz2;
};

export const sendMailsAsync = async (mails: {
  tos?: _ht.s[] | _ht.s,
  bccs?: _ht.s[] | _ht.s,
  sjt?: _ht.s,
  msg?: _ht.s,
}[]) => {
  await _hm.ectSrlAsync(mails.map((_mailz: _ht.dz) => async () => {
    await sendMailAsync(_mailz);
    return true;
  }));
};
